import {State} from '@ngxs/store';
import {AdvertiserBillingHoldsModel} from './advertiser-billing-holds.model';
import {Injectable} from '@angular/core';
import {AdvertiserBillingService} from '../../services-advertiser/billing/billing.service';
import {Observable} from 'rxjs';
import {IResponse} from '@interfaces/response';
import {IAdvertiserBillingHoldsActive, IAdvertiserBillingHoldsHistory} from '@interfaces/advertiser/billing';
import {finalize, tap} from 'rxjs/operators';
import {AdvertiserBillingHoldsSortType, AdvertiserBillingHoldsType} from '../../types/advertiser-billing-holds.type';
import {OrderType} from '../../types/order.type';
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

@StateRepository()
@State<AdvertiserBillingHoldsModel>({
  name: 'advertiserBillingHoldsState',
  defaults: {
    currentPage: 1,
    total: 0,
    search: '',
    order: 'DESC',
    itemsPerPage: 10,
    loader: false,
    holds: [],
    type: 'active',
    sort: 'id'
  }
})
@Injectable()
export class AdvertiserBillingHoldsState extends NgxsDataRepository<AdvertiserBillingHoldsModel> {
  constructor(private billingService: AdvertiserBillingService) {
    super();
  }

  @DataActionWithoutSubscription({cancelUncompleted: true})
  getHolds(): Observable<IResponse<IAdvertiserBillingHoldsHistory | IAdvertiserBillingHoldsActive>> {
    const limit = this.ctx.getState().itemsPerPage;
    const skip = limit * (this.ctx.getState().currentPage - 1);
    const order = this.ctx.getState().order;
    const search = this.ctx.getState().search;
    const type = this.ctx.getState().type;
    const sort = this.ctx.getState().sort;

    this.ctx.patchState({loader: true});
    return this.billingService.getBillingHolds({type, skip, order, search, limit, sort})
      .pipe(
        tap((holds) => {
          const state = this.ctx.getState();
          this.ctx.setState({...state, holds: holds.rows, total: holds.count});
        }),
        finalize(() => this.ctx.patchState({loader: false}))
      );
  }

  @DataActionWithoutSubscription()
  getHoldsByType(@Payload('[Advertiser billing holds] get holds by type') type: AdvertiserBillingHoldsType): Observable<any> {
    this.ctx.patchState({type, currentPage: 1, search: ''});
    return this.getHolds();
  }

  @DataActionWithoutSubscription()
  search(@Payload('[Advertiser billing holds] search holds') search: string): Observable<any> {
    this.ctx.patchState({search, currentPage: 1});
    return this.getHolds();
  }

  @DataActionWithoutSubscription()
  setPage(@Payload('[Advertiser billing holds] get holds by page') page: number): Observable<any> {
    this.ctx.patchState({currentPage: page});
    return this.getHolds();
  }

  @DataActionWithoutSubscription()
  sort(@Payload('[Advertiser billing holds] sort holds')
         payload: { sort: AdvertiserBillingHoldsSortType, order: OrderType }): Observable<any> {
    this.ctx.patchState({order: payload.order, sort: payload.sort});
    return this.getHolds();
  }
}
